// @flow

import React from 'react';
import { colors } from '../../style'

type Props = {
  hovered: boolean,
  width: number,
  height: number,
  className: string,
}

function DownloadIcon({ hovered, width, height, className }: Props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 62 41" width={width} height={height} className={className}>
      <g fill="none" fillRule="evenodd" stroke={hovered ? colors.red : colors.black} strokeWidth="2" strokeLinecap="round">
        <path d="M31 29V1"/>
        <path d="M44.1 17.99L31 31.09l-13.1-13.1" strokeLinejoin="round"/>
        <path d="M61 27.022v12H1v-12" strokeLinejoin="round"/>
      </g>
    </svg>
  )
}

export default DownloadIcon;



// WEBPACK FOOTER //
// ./src/components/Book/DownloadIcon.js